export function buildURLSearchParams(search: string) {
  return new URLSearchParams(search);
}
